import React from 'react';
import { Popover, Button, Icon, Input } from 'antd';

export const Difference = ({ onChange, params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      <Input
        allowClear
        value={params?.value}
        onChange={(event) => {
          const value = event.target.value;
          onChange({ ...params, value });
        }}
        placeholder='Difference'
      />
    </>
  );

  return (
    <Popover content={content} title='Difference' trigger='click'>
      <Button className='sighting-filter'>
        Difference
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
